import ajax from './ajax';

import { queryParams } from '../helpers/routeHelper';

export function getItemList(itemName, queryParamsObj, perPage, page) {
  return ajax(`/${itemName}${queryParams(itemName, queryParamsObj, perPage, page)}`);
}

export function callApi(queryParams) {
  return ajax('/products?' + queryParams);
}

export function postReview(params) {
  return ajax('/product_reviews', { method: 'POST', data: params });
}

export function getAllReviews(productId) {
  return ajax(`/products/reviews?product_id=${productId}`)
}

export function getSimilarProducts(productId) {
  return ajax(`/products?ProductsSearch[similar_of]=${productId}`);
}
